import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ThemeContext } from '../../App'
import { ITHORStakingStats } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getTSStakingYieldConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorswap', 'thor_staking_stats', timeframe)) as ITHORStakingStats[]

	const series1 = chartData.map((element: ITHORStakingStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VTHOR_YIELD_USD }
	})
	const series2 = chartData.map((element: ITHORStakingStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.UTHOR_YIELD }
	})
	const series3 = chartData.map((element: ITHORStakingStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.YTHOR_YIELD }
	})
	const series4 = chartData.map((element: ITHORStakingStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.YIELD_CUMULATIVE }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'vThor yield',
			type: 'bars',
			seriesGroup: '[usd]',
			color: 'orange',
			unitSymbol: '$',
			barGroup: 'thor'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'uThor yield',
			type: 'bars',
			seriesGroup: '[usd]',
			color: 'green',
			unitSymbol: '$',
			barGroup: 'thor'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'yThor yield',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `#0ffc03`,
			unitSymbol: '$',
			barGroup: 'thor'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'cumulative yield',
			type: 'line',
			seriesGroup: ' [usd]',
			color: `${color}`,
			unitSymbol: '$'
		}
	]
	return { config: config, latestValue: series4[series4.length - 1].y, latestValueDate: series4[series4.length - 1].x }
}

const TSStakingYield = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTSStakingYieldConfig, '1w')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="THOR Staking Yield"
			chartDesc="USD Amount rewarded to each of the THOR staking contracts."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="36b3b6b9-9e9c-4eef-a42f-a31fe7af0775"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}

export default TSStakingYield
